/* eslint-disable import/prefer-default-export */

export const Video = {
  BENEFITS_LOOP: 'Benefits Loop',
  BENEFITS: 'Benefits',
  COVID: 'Covid',
  DEMO: 'Demo',
};

export const VideoAction = {
  PAUSE: 'User Paused Video',
  PLAY: 'User Started Video',
  STOP: 'User Stopped Video',
};
